import styled from '@emotion/styled';

type MorePanelStyleTypes = {
  paddingTop?: number;
  paddingBottom?: number;
  background?: string;
  bgPath?: string;
};

export const MorePanelStyle = styled.section<MorePanelStyleTypes>`
  article {
    overflow: hidden;
  }
`;